<script>
export default {
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render(h) {
        return h({
            template: `<div>${this.html}</div>`,
            components: {
                NewsletterCompact: () => import('~/components/NewsletterCompact.vue'),
                CamperMaintenanceAd: () => import('~/components/magazine/CamperMaintenanceAd.vue'),
                Accordion: () => import('~/components/Accordion.vue'),
            },
        });
    },
};
</script>
